// components/Card.js - Card component
import React from 'react';

function Card({ id, front, back, matched, flipped, onClick }) {
  return (
    <div
      className={`card ${flipped ? 'flipped' : ''} ${matched ? 'matched' : ''}`}
      onClick={() => onClick(id)}
    >
      <div className="card-inner">
        <div className="card-front">
          <img src={front} alt="Card front" />
        </div>
        <div className="card-back">
          <img src={back} alt="Card back" />
        </div>
      </div>
    </div>
  );
}

export default Card;
